import request from '@/plugins/request';
import axios from '@/plugins/axios';
export function bilibili_video(params) {
    return request  ({
      url: '/api/bilibili_video',
      method: 'get',
      params
    });
  }
  export function bilibili_video2(params) {
    return request  ({
      url: '/api/bilibili_video2',
      method: 'get',
      params
    });
  }

  export function bilibili_video3(params) {
    return request  ({
      url: '/api/bilibili_video3',
      method: 'get',
      params
    });
  }

   export function bilibili_video4(params) {
    return request  ({
      url: '/api/bilibili_video4',
      method: 'get',
      params
    });
  }

    export function bilibili_video8(params) {
    return request  ({
      url: '/api/bilibili_video8',
      method: 'get',
      params
    });
  }

  export function bilibili_video_comments(params) {
    return request  ({
      url: '/api/bilibili_video_comment',
      method: 'get',
      params
    });
  }

  export function bilibili_video_comments2(params) {
    return request  ({
      url: '/api/bilibili_video_comment2',
      method: 'get',
      params
    });
  }

  export function bilibili_video_comments3(params) {
    return request  ({
      url: '/api/bilibili_video_comment3',
      method: 'get',
      params
    });
  }
  export function bilibili_video_comments4(params) {
    return request  ({
      url: '/api/bilibili_video_comment4',
      method: 'get',
      params
    });
  }

   export function bilibili_video_comments8(params) {
    return request  ({
      url: '/api/bilibili_video_comment8',
      method: 'get',
      params
    });
  }

  export function delete_bilibili_video(user_id) {
    return request({
      url: `/bilibili_video/${user_id}`, // 使用模板字符串插入 taskId
      method: 'delete',
    });
  }

  export function delete_bilibili_video_comment(user_id) {
    return request({
      url: `/bilibili_video_comment/${user_id}`, // 使用模板字符串插入 taskId
      method: 'delete',
    });
  }